import { Accordion, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconUsersGroup, IconX } from "@tabler/icons-react";
import NewsletterBlacklistsExclusion from "./NewsletterBlacklistsExclusion";
import NewsletterSentCampaignExclusion from "./NewsletterSentCampaignExclusion";
import { useLanguage } from "../../../stores/LanguageStore";

const NewsletterExclusion = ({
  campaignId,
  blacklistIds,
  setBlacklistIds,
  sentCampaignIds,
  setSentCampaignIds,
}) => {
  const lang = useLanguage(s => s.language)
  return (
    <Accordion
      variant="contained"
      bg={"#fff"}
      radius={"xl"}
      //   defaultValue={"list"}
      mt={"md"}
    >
      <Accordion.Item value="list">
        <Accordion.Control>
          <Group>
            <ThemeIcon variant="light" size={"xl"} radius={"xl"} color="red">
              <IconX />
            </ThemeIcon>
            <Stack gap={0}>
              <Group>
                <Text fw={600}>{lang.newsletter.step_3_title}</Text>
                <Text c="dimmed" size="sm">
                  {lang.newsletter.optional}
                </Text>
              </Group>
              <Text c="dimmed">{lang.newsletter.step_3_desc}</Text>
            </Stack>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <Stack>
            <NewsletterBlacklistsExclusion
              blacklistIds={blacklistIds}
              setBlacklistIds={setBlacklistIds}
            />

            <NewsletterSentCampaignExclusion
              sentCampaignIds={sentCampaignIds}
              setSentCampaignIds={setSentCampaignIds}
              campaignId={campaignId}
            />
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default NewsletterExclusion;
